export enum ReconciliationView {
  Classic = 'classic',
  Transactions = 'transactions',
}
